import { Component, Prop, Watch } from "vue-property-decorator";
import { InputMessage, InputOption } from "../../../../../models/Input";
import InputDefaultForm from "../../../default/InputDefaultForm";

@Component
export default class InputTelephoneForm extends InputDefaultForm {
	@Prop()
	public dataInputOption!: InputOption;

	public mounted(): void {
		this.dataInputOption.max = 20;
	}

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();

		if (this.dataInputOption.error) {
			return;
		}

		if (this.dataInputOption.vmodel !== "") {
			this.success = false;
			this.dataInputOption.error = false;
			const phoneRegex = new RegExp("^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$", "g");

			if (phoneRegex.test(this.dataInputOption.vmodel)) {
				this.success = true;
			} else {
				this.dataInputOption.error = true;
				this.dataInputOption.message = InputMessage.PhoneInvalid;
			}
		}
	}

	public blur(): void {
		if (this.dataInputOption.display?.length === this.dataInputOption.max) {
			this.dataInputOption.display = this.dataInputOption.display!.replace(/\d{2}(?!$)/g, "$& ");
		}
	}

	public focus(e: any): void {
		this.dataInputOption.display = this.dataInputOption.display!.replace(/\s/g, "");

		setTimeout(() => {
			e.target.select();
		}, 1);
	}

	public keydown(): void {
		this.$emit("changed");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/InputNumber/InputTelephoneForm/InputTelephoneForm.ts